import * as React from "react";

import "./edit-mailing-list-modal-mobile.scss";

import {cs}                     from "@Common/react/chain-services";
import {consumeContext}         from "@Common/react/context";
import {Load2}                  from "@Common/react/load2";
import {ModalService3}          from "@Common/ui-components/modal-service-3/modal-service-3";
import {UseState}               from "@Common/react/use-state";
import {Pagination}             from "@Common/ui-components/heavy/common/design2/data-table/pagination";
import {getPageSummary}         from "@Common/ui-components/heavy/common/design2/data-table/get-page-summary";
import {PageList}               from "@Common/ui-components/heavy/common/design2/pagination-ui/page-list/page-list";
import {PageSize}               from "@Common/ui-components/heavy/common/design2/pagination-ui/page-size/page-size";
import {MlAddressCard}          from "../ml-address-card/ml-address-card";
import {AddressModalA}          from "@Common/ui-components/heavy/mailing-ui/ml-addresses-table/address-modal-a";

const PAGE_SIZES = [5, 10, 20]
export const API_REQUEST_SUCCESS = "success"

export const EditMailingListModalMobile = ({mailingList, entityId, next: rootNext}) => cs(
    consumeContext("apis"),
    ["addresses", ({apis}, next) => Load2({
        fetch: () => apis.next.mailing.getMailingListDetails(mailingList.id),
        next,
    })],
    ["pageSize", (_, next) => UseState({next, getInitValue: () => PAGE_SIZES[0]})],
    ["pagination", ({addresses, pageSize}, next) => Pagination({
        _key: JSON.stringify(pageSize),
        pageSize: pageSize.value,
        rows: addresses?.value?.addresses,
        next,
    })],
    ["displayedRows", ({pagination, addresses}, next) => next(pagination?.active ? pagination.getDisplayedRows() : addresses?.value?.addresses)],
    ["modal", ({}, next) => ModalService3({
        xdQaName: "Edit Mailing List Modal",
        rootNext,
        next
    })],
    ["addressModal", (_, next) => AddressModalA({next})], 
    ({pagination, pageSize, displayedRows, addresses, addressModal, apis}) => (
        <div className='mailing-list-mobile-Fe2O3'>
            <div className='mailing-list-mobile-header'>
                <div className='mailing-list-mobile-header-row'>
                    <div className='mailing-list-mobile-header-column'>
                        <div className='mailing-list-mobile-header-label'>
                            Edit Mailing List
                        </div>
                        <div className='mailing-list-mobile-header-title'>
                            {mailingList.mailingListName}
                        </div>
                    </div>
                    <div className='mailing-list-mobile-header-column'>
                        <div 
                            className='mailing-list-mobile-add-new'
                            onClick={ (e) => {
                                e.stopPropagation()
                                addressModal.show({
                                    actionName: "add",
                                    onConfirm: (address, action) => {
                                        (async () => {
                                            const additionSuccessful = await apis.next.mailing.addMailingAddress(address, entityId, mailingList.id)
                                            if(API_REQUEST_SUCCESS === additionSuccessful.result) {
                                                addresses.reload()
                                            }                                        
                                        })()
                                        return action
                                    }
                                })
                            }}
                        >
                            ADD NEW ADDRESS
                        </div>
                    
                    </div>
                </div>
            </div>
            {
                displayedRows?.map(address => 
                    <React.Fragment key={address.idPrimary}>
                        <MlAddressCard {...{address, addresses, entityId}}/>
                    </React.Fragment>
                 )               
            }
            {
                displayedRows?.length
                ?
                <div className="controls">
                    <div className="pagination-row">
                        {
                            PageSize({
                                sizes: PAGE_SIZES,
                                state: pageSize,
                                pageSizeMessage: "",
                            })
                        }
                        {
                            pagination.active
                            ? 
                            <div className="pagination">
                                {PageList(pagination)}
                            </div>
                            :
                            null
                        }
                    </div>
                    {
                        getPageSummary({
                            pageIndex: pagination.state.value,
                            pageSize: pageSize.value,
                            count: addresses.value.addresses.length
                        })
                    }
                </div>
                : 
                <div className='placeholder'>
                    {MESSAGE_PLACEHOLDER}
                </div>
            }          
        </div>        
    )
);

const MESSAGE_PLACEHOLDER = `No addresses in list.`